import type { ReactNode } from 'react';

import styles from './CardGrid.module.css';

export interface CardGridProps {
  /**
   * Cards per row once there is room: 2 (the default, like the reference layout) from a
   * 720px-wide content panel, or 3 from 1100px (two in between). One column below 720px.
   */
  columns?: 2 | 3;
  children: ReactNode;
}

/**
 * Lays cards (Sections) out side by side so they fill the width of the content panel
 * (ADR 0019). Cards in a row share its height. Give a card's wrapper `data-span="full"` to
 * make it take a whole row.
 */
export function CardGrid({ columns = 2, children }: CardGridProps) {
  return (
    <div className={styles.frame}>
      <div className={styles.grid} data-card-grid data-columns={columns}>
        {children}
      </div>
    </div>
  );
}
